import React, { Component } from "react";
import { FaBars } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";
import {
  NavBox,
  NavBar,
  NavLogo,
  Burger,
  NavMenu,
  NavItem,
  NavLinks,
  NavButton,
  NBLink,
} from "./atoms";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = { navScroll: false };
    this.setScrollNav = this.setScrollNav.bind(this);
  }
  setScrollNav() {
    window.scrollY >= 80
      ? this.setState({ scrollNav: true })
      : this.setState({ scrollNav: false });
  }
  goHome() {
    scroll.scrollToTop();
  }
  render() {
    window.addEventListener("scroll", this.setScrollNav);
    return (
      <>
        <NavBox scrollNav={this.state.scrollNav}>
          <NavBar>
            <NavLogo to="/" onClick={this.goHome}>
              <h1>evan</h1>
            </NavLogo>
            <Burger onClick={this.props.toggleSlider}>
              <FaBars />
            </Burger>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to="about"
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-20}
                >
                  About
                </NavLinks>
              </NavItem>
              {/* <NavItem>
                <NavLinks
                  to="discover"
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                >
                  Discover
                </NavLinks>
              </NavItem> */}
              <NavItem>
                <NavLinks
                  to="skills"
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-20}
                >
                  Skills
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="projects"
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-20}
                >
                  Projects
                </NavLinks>
              </NavItem>
            </NavMenu>
            <NavButton>
              <NBLink href={process.env.PUBLIC_URL + "/cv.pdf"}>
                Download CV
              </NBLink>
            </NavButton>
          </NavBar>
        </NavBox>
      </>
    );
  }
}

export default Nav;
